export const totalCostCalculator = (
  lateFeesAmount: number,
  productPrice: number | null,
  prePaidAmount: number = 0,
  backDuesAmount: number = 0
): number => {
  let totalCost = lateFeesAmount;

  if (typeof productPrice === "number") {
    totalCost +=
      productPrice - prePaidAmount >= 0 ? productPrice - prePaidAmount : 0;
  }

  totalCost += backDuesAmount;

  return totalCost;
};

export default {};
